/**
 * Privacy callout.
 *
 * Asking a group to type where they live is a trust decision, so the page states
 * what happens to a precise location before the visitor is asked for one: the
 * coordinates only feed the commute estimate, everyone else sees the area name.
 */

import { Check, ShieldCheck } from 'lucide-react'
import { useTranslation } from 'react-i18next'

export function PrivacyCallout() {
  const { t } = useTranslation()

  const points = [
    t('home.privacyPointOne'),
    t('home.privacyPointTwo'),
    t('home.privacyPointThree'),
  ]

  return (
    <section className="landing-section" aria-labelledby="landing-privacy-title">
      <div className="landing-container">
        <div className="border-border bg-card flex flex-col gap-3 rounded-3xl border p-3.5 sm:gap-6 sm:p-8 lg:flex-row lg:items-center lg:justify-between">
          <div className="flex min-w-0 flex-col gap-2 sm:gap-3">
            <span className="text-muted-foreground inline-flex items-center gap-2 text-xs font-medium tracking-wide uppercase">
              <ShieldCheck className="size-4" aria-hidden />
              {t('guide.privacyTitle')}
            </span>
            <h2
              id="landing-privacy-title"
              className="max-w-xl text-2xl font-semibold tracking-tight text-balance"
            >
              {t('home.privacyTitle')}
            </h2>
            <p className="text-muted-foreground max-w-xl text-sm">{t('home.privacyBody')}</p>
          </div>

          <ul className="flex flex-col gap-2 sm:gap-3">
            {points.map((point) => (
              <li key={point} className="flex items-start gap-2 text-sm">
                <Check className="text-primary mt-0.5 size-4 shrink-0" aria-hidden />
                <span className="min-w-0">{point}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  )
}
